import { render, staticRenderFns } from "./year-detail.vue?vue&type=template&id=620fee4e"
import script from "./year-detail.vue?vue&type=script&lang=js"
export * from "./year-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports